/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import InlineResponse2006Goals from './InlineResponse2006Goals';

/**
 * The InlineResponse2006 model module.
 * @module model/InlineResponse2006
 * @version v0.3
 */
export default class InlineResponse2006 {
  /**
   * Constructs a new <code>InlineResponse2006</code>.
   * @alias module:model/InlineResponse2006
   * @class
   * @param firstName {String}
   * @param goals {Array.<module:model/InlineResponse2006Goals>}
   */
  constructor(firstName, goals) {
    this.firstName = firstName;
    this.goals = goals;
  }

  /**
   * Constructs a <code>InlineResponse2006</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2006} obj Optional instance to populate.
   * @return {module:model/InlineResponse2006} The populated <code>InlineResponse2006</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2006();
      if (data.hasOwnProperty('first_name'))
        obj.firstName = ApiClient.convertToType(data['first_name'], 'String');
      if (data.hasOwnProperty('goals'))
        obj.goals = ApiClient.convertToType(data['goals'], [InlineResponse2006Goals]);
    }
    return obj;
  }
}

/**
 * @member {String} firstName
 */
InlineResponse2006.prototype.firstName = undefined;

/**
 * @member {Array.<module:model/InlineResponse2006Goals>} goals
 */
InlineResponse2006.prototype.goals = undefined;
